import { scheduleChangeRowDescription, scheduleDayKeyToShort } from "./scheduleComponents";

function formatLastViewed(iso, lang) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return "";
    return d.toLocaleString(lang === "gr" ? "el-GR" : "en-GB", {
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

export function ScheduleUnseenBanner({ lang, slots, lastViewedAt, onDismiss, onOpenSlot }) {
  if (!slots?.length) return null;
  const t = (en, gr) => (lang === "gr" ? gr : en);
  const when = formatLastViewed(lastViewedAt, lang);
  return (
    <div
      style={{
        marginBottom: 10,
        padding: "10px 12px",
        borderRadius: 12,
        border: "1.5px solid #F59E0B",
        background: "#FFFBEB",
      }}
    >
      <div style={{ display: "flex", alignItems: "flex-start", gap: 10, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#92400E" }}>
            {slots.length === 1
              ? t("1 slot changed since you last opened this week", "1 slot άλλαξε από την τελευταία φορά που ανοίξατε αυτή την εβδομάδα")
              : t(
                  `${slots.length} slots changed since you last opened this week`,
                  `${slots.length} slots άλλαξαν από την τελευταία φορά που ανοίξατε αυτή την εβδομάδα`
                )}
          </div>
          {when ? (
            <div style={{ fontSize: 11, color: "#B45309", marginTop: 2, fontWeight: 600 }}>
              {t(`Last opened ${when}`, `Τελευταία προβολή ${when}`)}
            </div>
          ) : null}
        </div>
        <button
          type="button"
          onClick={onDismiss}
          style={{
            border: "none",
            background: "transparent",
            color: "#92400E",
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            padding: "4px 6px",
          }}
        >
          {t("Got it", "Το είδα")}
        </button>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: 6, marginTop: 8 }}>
        {slots.map((slot) => (
          <button
            key={slot.key}
            type="button"
            onClick={() => onOpenSlot?.(slot)}
            style={{
              textAlign: "left",
              border: "1px solid #FDE68A",
              background: "#fff",
              borderRadius: 8,
              padding: "7px 10px",
              cursor: "pointer",
            }}
          >
            <div style={{ fontSize: 12, fontWeight: 700, color: "var(--text-primary)" }}>
              {slot.employee_name || slot.employee_code} · {scheduleDayKeyToShort(slot.day_key, lang)} {slot.date}
            </div>
            <div style={{ fontSize: 11, color: "var(--text-muted)", marginTop: 2 }}>
              {scheduleChangeRowDescription(slot.latest || {}, lang)}
              {slot.latest?.changed_by_name
                ? lang === "gr"
                  ? ` · από ${slot.latest.changed_by_name}`
                  : ` · by ${slot.latest.changed_by_name}`
                : ""}
              {slot.count > 1 ? (lang === "gr" ? ` · ${slot.count} αλλαγές` : ` · ${slot.count} changes`) : ""}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

export function UnseenSlotMarker({ lang, visible }) {
  if (!visible) return null;
  const title = lang === "gr" ? "Άλλαξε από την τελευταία προβολή" : "Changed since you last viewed";
  return (
    <span
      title={title}
      aria-label={title}
      style={{
        position: "absolute",
        bottom: 3,
        right: 4,
        width: 8,
        height: 8,
        borderRadius: "50%",
        background: "#D97706",
        border: "1px solid #fff",
        boxShadow: "0 0 0 1px rgba(120,53,15,0.25)",
        zIndex: 4,
      }}
    />
  );
}
